import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  standalone: false
})
export class ModalHeaderComponent {
  @Input() title: string = '';
  @Input() showCloseButton: boolean = true;
  // TODO(migracion-ng21): renombrar a 'closed'. 'close' colisiona con un evento
  // nativo del DOM. Regla detectada al subir a angular-eslint 19; el codigo es
  // previo a la migracion. El rename cambia la API de un componente compartido
  // usado en 4 templates, asi que queda fuera del alcance del bump de version.
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}

